import React from "react";
import { useQuery } from "@apollo/react-hooks";

import Layout from "components/Layout";
import DataTable, { mapData } from "components/DataTable";
import PieChart from "components/chart/PieChart";
import Scrollable from "components/Scrollable";
import withAuth from "components/withAuth";
import { H1, H2, P, Section } from "styles";
import { SOURCE } from "queries";

interface Sources {
  [key: string]: number;
}

function Source() {
  const { data: { sources } = { sources: [] } } = useQuery(SOURCE);

  const data = mapData(sources);

  return (
    <Layout>
      <Section>
        <H1>Source</H1>
        <P>Contact sources includes online services and others.</P>
        <DataTable
          headers={["", "Source", "Count"]}
          data={data}
          link="/contact/source/"
        />
      </Section>
      <Section>
        <H2>Source Count</H2>
        <Scrollable>
          <PieChart data={data} />{" "}
        </Scrollable>
      </Section>
    </Layout>
  );
}

export default withAuth(Source);
